import React from 'react';
import { INSIGHTS } from '../data/fuelData';
import './Insights.scss';

export default function Insights() {
  return (
    <section className="insights">
      <div className="insights__inner">
        <div className="insights__header">
          <p className="insights__label">Updated Daily</p>
          <h2 className="insights__title">Smart Insights</h2>
        </div>
        <div className="insights__grid">
          {INSIGHTS.map((ins, i) => (
            <div key={i} className="insight-card">
              <div className="insight-card__icon">{ins.icon}</div>
              <div className="insight-card__label">{ins.label}</div>
              <div className="insight-card__value">{ins.value}</div>
              <div className="insight-card__sub">{ins.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
